export default __webpack_public_path__ + "static/media/friedsnacksdiner.e08df7f3.png";